module.exports = __webpack_public_path__ + "static/07_rimohab_mov_v6-eebffe76a45862f4060360bb91b21243.mp4";